import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/2026/footer-mobile-bottom-circle.png")